import {
  ArrowUpFromLine,
  ChevronsDown,
  Footprints,
  Mouse,
  MouseLeft,
  MouseRight,
  PersonStanding,
  Rabbit,
} from "lucide-react";
import type {
  ThrowMouse,
  ThrowMovement,
  ThrowTechniqueAxes,
} from "./throw-technique.js";

const movementIcons: Record<ThrowMovement, typeof PersonStanding> = {
  STAND: PersonStanding,
  GEHEND: Footprints,
  LAUFEND: Rabbit,
  DUCK: ChevronsDown,
};

const mouseIcons: Record<ThrowMouse, typeof Mouse> = {
  LINKSKLICK: MouseLeft,
  RECHTSKLICK: MouseRight,
  BEIDE_MAUSTASTEN: Mouse,
};

/** Symbol-Reihe für eine Wurftechnik-Kombination — je Achse ein Icon, kombiniert im Trigger und in den Optionen. */
export function ThrowTechniqueIcon({
  axes,
  size = 14,
}: {
  axes: ThrowTechniqueAxes;
  size?: number;
}) {
  const MovementIcon = movementIcons[axes.movement];
  const MouseButtonIcon = mouseIcons[axes.mouse];
  return (
    <span className="throw-technique-icon" aria-hidden="true">
      <MovementIcon size={size} />
      {axes.jump === "JUMPTHROW" ? <ArrowUpFromLine size={size} /> : null}
      <MouseButtonIcon size={size} />
    </span>
  );
}
